import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineMinimizeWindow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M5.9 6.95h3.15v3.15M9.05 6.95l-4.2 4.2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M2.75 14.3h7.875c.58 0 1.05-.47 1.05-1.05V5.375c0-.58-.47-1.05-1.05-1.05H2.75c-.58 0-1.05.47-1.05 1.05v7.875c0 .58.47 1.05 1.05 1.05"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M5.375 1.7h7.875c.58 0 1.05.47 1.05 1.05v7.875"
    />
  </svg>
);
export default SvgStreamlineMinimizeWindow;
